const $ = require('jquery');

function MemoScroll() {
    this.scrollPositions = {};
}

/**
 * Restores a scroll position saved under the given name to the element. If no element is provided,
 * the scroll position is restored to the document.
 * @param {String} name - The name under which the scroll position was saved.
 * @param {(Element|jQuery|String)} [element=document] - The element which the scroll position should be restored to.
 */
MemoScroll.prototype.restoreScrollPosition = function (name, element) {
    if (name in this.scrollPositions) {
        $(element || document).scrollTop(this.scrollPositions[name]);
        this.forgetScrollPosition(name);
    }
};

/**
 * Remembers the scroll position of a given element.
 * @param {String} name - The name under which to save the scroll position.
 * @param {(Element|jQuery|String)} [element=document] - The element from which the scroll position should be fetched.
 */
MemoScroll.prototype.rememberScrollPosition = function (name, element) {
    this.scrollPositions[name] = $(element || document).scrollTop();
};

/**
 * Forgets the scroll position for a given memo.
 * @param {String} name  - The name of the memo to forget.
 * @returns {Boolean}
 */
MemoScroll.prototype.forgetScrollPosition = function (name) {
    return delete this.scrollPositions[name];
};

module.exports = MemoScroll;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/memoscroll/memoscroll-service.js
 **/